var _rect, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 35,
    viewBox: "0 0 36 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.23684,
    y: 0.583313,
    width: 33.3781,
    height: 33.8333,
    rx: 14.5,
    stroke: "url(#paint0_linear_300_56931)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2026 11.5625C21.2026 13.5781 19.7394 15.0666 18.1053 15.0666C16.4712 15.0666 15.0079 13.5781 15.0079 11.5625C15.0079 9.54681 16.4712 8.05831 18.1053 8.05831C19.7394 8.05831 21.2026 9.54681 21.2026 11.5625Z",
    stroke: "url(#paint1_linear_300_56931)",
    strokeWidth: 1.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.15 21.8541C25.15 22.8935 24.503 23.9468 23.2235 24.7807C21.9519 25.6096 20.1447 26.15 18.1053 26.15C16.0658 26.15 14.2586 25.6096 12.987 24.7807C11.7075 23.9468 11.0605 22.8935 11.0605 21.8541C11.0605 20.8148 11.7075 19.7615 12.987 18.9276C14.2586 18.0987 16.0658 17.5583 18.1053 17.5583C20.1447 17.5583 21.9519 18.0987 23.2235 18.9276C24.503 19.7615 25.15 20.8148 25.15 21.8541Z",
    stroke: "url(#paint2_linear_300_56931)",
    strokeWidth: 1.7
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_300_56931",
    x1: 0.736839,
    y1: 18.6611,
    x2: 35.115,
    y2: 18.6611,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E85EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2DD9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_300_56931",
    x1: 14.1579,
    y1: 11.8528,
    x2: 22.0526,
    y2: 11.8528,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E85EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2DD9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_300_56931",
    x1: 10.2105,
    y1: 22.1972,
    x2: 26,
    y2: 22.1972,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E85EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2DD9FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/profile-icon.b8fe21e80bb2f6a1504fe92716924f19.svg";
export { ForwardRef as ReactComponent };